import { render, staticRenderFns } from "./HeaderCompactGameCardInProgress.vue?vue&type=template&id=76f1f252"
import script from "./HeaderCompactGameCardInProgress.vue?vue&type=script&lang=js"
export * from "./HeaderCompactGameCardInProgress.vue?vue&type=script&lang=js"
import style0 from "./HeaderCompactGameCardInProgress.vue?vue&type=style&index=0&id=76f1f252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports